import React, { useState } from "react";
import {
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import "../../../assets/css/modal.css";

const ModalSignatureType = ({ onConfirm }) => {
  const navigate = useNavigate();
  const [signatureLevel, setSignatureLevel] = useState("advanced");
  const [authenticationMode, setAuthenticationMode] = useState("otp_sms");

  const handleSignatureLevelChange = (event) => {
    const level = event.target.value;
    setSignatureLevel(level);
    // Se scelgo firma avanzata, forzo OTP SMS
    if (level === "advanced") {
      setAuthenticationMode("otp_sms");
    } else {
      setAuthenticationMode("none");
    }
  };

  const handleAuthenticationModeChange = (event) => {
    setAuthenticationMode(event.target.value);
  };

  const handleConfirm = () => {
    onConfirm({
      signatureLevel,
      authenticationMode,
    });
  };

  const handleCancel = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/signing-pending");
    }
  };

  return (
    <Grid
      container
      item
      xs={11}
      md={6}
      sx={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "#fff",
        width: { xs: "90%", sm: "80%", md: "600px" },
        borderRadius: "2px",
      }}
    >
      <Grid
        item
        xs={12}
        style={{
          height: "60px",
          width: "100%",
          display: "flex",
          alignItems: "center",
          borderBottom: "1px solid #c6c6c6",
        }}
      >
        <Grid item xs={1} style={{ marginLeft: "15px" }}>
          <div className="icon-modal-info" />
        </Grid>
        <Grid item xs={10}>
          <Typography
            className="color-blue-dark"
            style={{ fontSize: "18px", fontWeight: 600 }}
          >
            Seleziona il livello di firma
          </Typography>
        </Grid>
      </Grid>

      <Grid container item xs={12} style={{ padding: "30px 20px" }}>
        <FormControl component="fieldset" fullWidth>
          <Typography
            className="color-blue-dark"
            style={{ fontSize: "16px", marginBottom: "15px" }}
          >
            La scelta del livello di firma applicato al signing è <strong>irrevocabile e si applica a tutti i firmatari</strong>. L'utente che avvia il signing ha la responsabilità sulla scelta del livello di firma.
          </Typography>
          <RadioGroup
            value={signatureLevel}
            onChange={handleSignatureLevelChange}
          >
            <FormControlLabel
              value="advanced"
              control={<Radio sx={{ color: '#1b2838', '&.Mui-checked': { color: '#1b2838' } }} />}
              label={
                <Typography className="color-blue-dark" style={{ fontWeight: 700 }}>
                  Firma Elettronica RAFFORZATA (consigliato)
                </Typography>
              }
              style={{ marginTop: "15px" }}
            />

            {signatureLevel === "advanced" && (
              <Grid
                container
                item
                xs={12}
                style={{ marginLeft: "32px", marginTop: "0px" }}
              >
                <Typography
                  className="color-blue-dark"
                  style={{ fontSize: "14px", fontStyle: "italic" }}
                >
                  Include riconoscimento ID e invio OTP sul cellulare del firmatario (Livello di sicurezza alto).
                </Typography>
              </Grid>
            )}

            <FormControlLabel
              value="electronic"
              control={<Radio sx={{ color: '#1b2838', '&.Mui-checked': { color: '#1b2838' } }} />}
              label={
                <Typography className="color-blue-dark" style={{ fontWeight: 700 }}>
                  Firma Elettronica SEMPLICE
                </Typography>
              }
              style={{ marginTop: "15px" }}
            />

            {signatureLevel === "electronic" && (
              <Grid
                container
                item
                xs={12}
                style={{ marginLeft: "32px", marginTop: "0px" }}
              >
                <Typography
                  className="color-blue-dark"
                  style={{ fontSize: "14px", fontStyle: "italic" }}
                >
                  Nessun riconoscimento ID o Invio OTP (Livello di sicurezza molto basso).
                </Typography>
              </Grid>
            )}


          </RadioGroup>
        </FormControl>
      </Grid>

      <Grid container item xs={12}>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "0 20px 20px 20px",
          }}
        >
          <Button
            onClick={handleCancel}
            sx={{
              backgroundColor: "#fff",
              border: "1px solid #1b2838",
              borderRadius: "0px",
              minWidth: "160px",
              "&:hover": {
                backgroundColor: "#f5f5f5",
                border: "1px solid #1b2838",
              }
            }}
          >
            <Typography
              sx={{
                color: "#1b2838",
                textTransform: "initial",
                fontSize: { xs: "16px", sm: "18px" },
                fontWeight: 500,
              }}
            >
              Annulla
            </Typography>
          </Button>
          <Button
            className="button-bg-purple"
            onClick={handleConfirm}
            sx={{ minWidth: "160px" }}
          >
            <Typography
              className="color-light"
              sx={{
                textTransform: "initial",
                fontSize: { xs: "16px", sm: "18px" },
                fontWeight: 500,
              }}
            >
              Conferma
            </Typography>
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ModalSignatureType;
